import moment from "moment";
import { EntityQueryResults } from "../api/models/EntityQueryResults";
import { UserCustomer } from "../api/models/UserCustomer";

export const requestHasEndingRepresenattions = (payload: EntityQueryResults<UserCustomer>) => {
    return payload.entities?.some((representation: UserCustomer) => representationIsEnding(representation));
        
}

export const representationIsEnding = (representation: UserCustomer) => {
    return representation.endDate ? moment(representation.endDate).isBefore(moment().add(1, 'months').endOf('month')) : false;
}